import { Link } from "react-router-dom"
import erro from '../../img/erro.png'
import './erro.css'


export default function Erro(){
    return(
        <div className="container">
            <h1> Ops! Página não encontrada!!! </h1>
                 <img className="erro" src={erro} alt='erro'/>
                 
                 <div className="voltar">
                         <Link to='/'> Veja todos os Filmes </Link>
                 </div>
           

        </div>
    )
}